import TablePositionSummary from './TablePositionSummary';

export default TablePositionSummary;
